import { SensitiveFieldInput } from "@/components/SensitiveFieldInput";
import type { GenericField } from "@shared/schema";

export interface SensitiveCellProps {
  field: Pick<GenericField, "id" | "name" | "fieldKey" | "fieldType">;
  value: string;
  onChange: (v: string) => void;
  onBlur: () => void;
  readOnly?: boolean;
  clientId: string;
  /** Row id for table/expandable rows; null for single-record card fields (s88). */
  rowId?: string | null;
  secureFileSetupAt: Date | null;
}

export function SensitiveCell(props: SensitiveCellProps) {
  return <SensitiveFieldInput {...props} variant="table" />;
}
